export const DATATEST = {
    BUTTON: "reusable__button-component__button",
};
